import { zGetInsuranceCampaignsForAdminEndpointInput } from '@/general/src/insuranceCampaign/routes/getInsuranceCampaignsForAdmin/input.js'
import { getInsuranceCustomerTypeTitle } from '@/general/src/insuranceCustomerType/shared.js'
import { getInsuranceTypeTitle } from '@/general/src/insuranceType/shared.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { Textfieldy, useFormy } from '@/webapp/src/lib/formy.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { adminInsuranceCampaignViewRoute } from '@/webapp/src/lib/routes.js'
import { SectionWrapper } from '@/webapp/src/lib/sectionWrapper.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Block, FormItems, Segment, Table } from '@/webapp/src/lib/uninty.components.js'
import { formatDate } from 'date-fns'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { canViewInsuranceCampaigns } from '../../../auth/can.js'

export const AdminInsuranceCampaignListPage = withPageWrapper({
  title: 'История страховок',
  Layout: GeneralLayout,
  authorizedAdminsOnly: true,
  checkAccess: ({ ctx }) => canViewInsuranceCampaigns(ctx.me.admin),
})(() => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const searchParamsObject = Object.fromEntries(searchParams.entries())
  const initalValues = useMemo(() => {
    return {
      insuranceCampaignSn: (searchParamsObject.insuranceCampaignSn || '') as never as number,
      insuranceCampaignIssueMessage: searchParamsObject.insuranceCampaignIssueMessage || '',
      insuranceCampaignIssueHash: searchParamsObject.insuranceCampaignIssueHash || '',
    }
  }, [])
  const [filter, setFilter] = useState(initalValues)
  const formy = useFormy({
    initialValues: initalValues as never,
    validationSchema: zGetInsuranceCampaignsForAdminEndpointInput,
  })
  useEffect(() => {
    void formy.setFieldTouched('insuranceCampaignSn', true, true)
    void formy.setFieldTouched('insuranceCampaignIssueMessage', true, true)
    void formy.setFieldTouched('insuranceCampaignIssueHash', true, true)
  }, [formy.values])
  useEffect(() => {
    if (zGetInsuranceCampaignsForAdminEndpointInput.safeParse(formy.values).success) {
      setFilter(formy.values as never)
    }
  }, [JSON.stringify(formy.values)])
  return (
    <Block fcnw>
      <Segment title="История страховок" size="m">
        <FormItems>
          <FormItems>
            <Textfieldy label="SN" {...formy.getFieldProps('insuranceCampaignSn')} />
            <Textfieldy label="Текст ошибки" {...formy.getFieldProps('insuranceCampaignIssueMessage')} />
            <Textfieldy label="Хеш ошибки" {...formy.getFieldProps('insuranceCampaignIssueHash')} />
          </FormItems>
          <SectionWrapper
            useInfiniteQuery={() =>
              trpc.getInsuranceCampaignsForAdmin.useInfiniteQuery(
                {
                  ...filter,
                },
                {
                  getNextPageParam: (lastPage) => {
                    return lastPage.nextCursor
                  },
                }
              )
            }
            setProps={({ infiniteQueryResult }) => ({
              insuranceCampaigns: infiniteQueryResult.data?.pages.flatMap((page) => page.insuranceCampaigns) ?? [],
              infiniteQueryResult,
            })}
          >
            {({ insuranceCampaigns, infiniteQueryResult }) => {
              return (
                <Table
                  records={insuranceCampaigns}
                  href={(record) => adminInsuranceCampaignViewRoute.get({ insuranceCampaignSn: record.sn })}
                  columns={[
                    { heading: 'SN', body: (record) => record.sn, width: 70 },
                    { heading: 'Агент', body: (record) => record.agent.sn, width: 70 },
                    { heading: 'Клиент', body: (record) => record.clientName, width: 200 },
                    {
                      heading: 'Тип клиента',
                      body: (record) => getInsuranceCustomerTypeTitle(record.insuranceCustomerType),
                      width: 120,
                    },
                    {
                      heading: 'Тип страховки',
                      body: (record) => getInsuranceTypeTitle(record.insuranceType),
                      width: 160,
                    },
                    {
                      heading: 'Дата создания',
                      body: (record) => formatDate(record.createdAt, 'dd.MM.yyyy HH:mm'),
                      width: 140,
                    },
                  ]}
                  loadMore={() => {
                    if (!infiniteQueryResult.isFetchingNextPage && infiniteQueryResult.hasNextPage) {
                      void infiniteQueryResult.fetchNextPage()
                    }
                  }}
                  hasMore={infiniteQueryResult.hasNextPage}
                />
              )
            }}
          </SectionWrapper>
        </FormItems>
      </Segment>
    </Block>
  )
})
